import { FC } from 'react';

import { MotionValue } from 'framer-motion';

import useAnimator from './useAnimator';

const OrangeAbstractBackground: FC<{
  motionValue: MotionValue;
}> = ({ motionValue, ...props }) => {
  const { Group, Svg } = useAnimator(motionValue);
  return (
    <Svg
      viewBox='0 0 1440 709'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g id='Seller' clipPath='url(#clip0_156_558)'>
        <rect width='1440' height='680' fill='#FFF6F3' />
        <g id='Frame' clipPath='url(#clip1_156_558)'>
          <g id='Group'>
            <path
              id='Vector'
              d='M1440 -468H0V688H1440V-468Z'
              fill='url(#paint0_linear_156_558)'
            />
            <Group id='left-1-5' custom={-1} opacity='0.3'>
              <g id='Group_2' opacity='0.3'>
                <g id='Group_3' opacity='0.3'>
                  <path
                    id='Vector_2'
                    opacity='0.3'
                    d='M0 529.625V-383.563L36.9231 -341.334L142.418 -235.764L327.033 -56.2933L332.308 -45.7362L453.626 75.6702L427.253 96.7843L0 529.625Z'
                    fill='#FFF1ED'
                  />
                </g>
                <path
                  id='Vector_3'
                  opacity='0.3'
                  d='M0 270.995V-468H738.462L327.033 -56.274L300.659 -29.8813L0 270.995Z'
                  fill='#FFF1ED'
                />
              </g>
              <g id='Group_4' opacity='0.4'>
                <g id='Group_5' opacity='0.4'>
                  <path
                    id='Vector_4'
                    opacity='0.4'
                    d='M15.8242 687.981H0V-330.777L10.5495 -314.941L116.044 -209.37L300.659 -29.8999L305.934 -24.6214L427.253 96.7851L516.923 186.52L15.8242 687.981Z'
                    fill='#FFF1ED'
                  />
                </g>
                <path
                  id='Vector_5'
                  opacity='0.3'
                  d='M0 286.831V-468H754.286L332.308 -45.7169L305.934 -24.6028L0 286.831Z'
                  fill='#FFF1ED'
                />
              </g>
            </Group>
            <g id='Group_6'>
              <g id='Group_7'>
                <Group custom={2} id='right-2-2'>
                  <path
                    id='Vector_6'
                    d='M1437.79 286.344C1462.99 261.131 1506.09 278.975 1506.09 314.618V666.383C1506.09 701.84 1463.37 719.767 1438.07 694.931L1260.61 520.756C1244.74 505.183 1244.62 479.66 1260.33 463.934L1437.79 286.344Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <Group custom={1}>
                  <path
                    id='right-1-1'
                    opacity='0.3'
                    d='M1506.08 349.965V951.718H1221.24L1063 793.362L1506.08 349.965Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <Group custom={2} id='right-2-1'>
                  <path
                    id='Vector_7'
                    d='M1598.23 547.149C1629.72 515.633 1683.6 537.937 1683.6 582.491V1000.31C1683.6 1027.93 1661.21 1050.31 1633.6 1050.31H1553.5C1540.24 1050.31 1527.51 1045.04 1518.14 1035.66L1349.42 866.819C1329.91 847.296 1329.91 815.657 1349.42 796.134L1598.23 547.149Z'
                    fill='url(#paint1_linear_156_558)'
                  />
                </Group>
              </g>
            </g>
            <g id='Group_8'>
              <g id='Group_9'>
                <Group id='left-1-4' custom={-1}>
                  <path
                    id='Vector_8'
                    d='M291.92 683.731C323.436 715.224 301.131 769.1 256.577 769.1L-43.889 769.1C-88.6774 769.1 -110.874 714.74 -78.8865 683.39L72.8052 534.723C92.3817 515.537 123.756 515.689 143.145 535.064L291.92 683.731Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <Group custom={-1}>
                  <path
                    id='left-1-3'
                    opacity='0.3'
                    d='M-59 519.196V-72H220.56L378.802 86.3562L-59 519.196Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <Group custom={-2} id='left-2-4'>
                  <path
                    id='Vector_9'
                    d='M9.29453 266.104C-15.8999 291.316 -59 273.473 -59 237.83V-32C-59 -54.0914 -41.0914 -72 -19 -72H24.6428C35.2564 -72 45.435 -67.7818 52.9373 -60.2741L165.933 52.8036C181.541 68.4222 181.541 93.7331 165.933 109.352L9.29453 266.104Z'
                    fill='#FFECE5'
                  />
                </Group>
              </g>
              <g id='Group_10' opacity='0.4'>
                <Group custom={-1}>
                  <path
                    id='left-1-2'
                    opacity='0.3'
                    d='M26.3681 394.324C-5.1249 425.839 -59 403.535 -59 358.981V-72.0001C-59 -99.6143 -36.6142 -122 -9 -122H478.634C485.637 -122 492.353 -119.217 497.303 -114.263V-114.263C507.601 -103.958 507.601 -87.257 497.303 -76.9516L136.165 284.447L26.3681 394.324Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <Group custom={-2} id='left-2-3' opacity='0.4'>
                  <path
                    id='Vector_10'
                    opacity='0.4'
                    d='M-16.8022 136.648C-32.3693 152.227 -59 141.202 -59 119.178V-72C-59 -99.6143 -36.6142 -122 -9 -122H185.367C191.014 -122 196.43 -119.756 200.421 -115.761V-115.761C208.659 -107.517 208.734 -94.1805 200.589 -85.8445L-16.8022 136.648V136.648Z'
                    fill='#FFECE5'
                  />
                </Group>
              </g>
            </g>
            <g id='Group_11' opacity='0.7'>
              <g id='Group_12' opacity='0.4'>
                <Group custom={-2} id='left-2-2' opacity='0.4'>
                  <path
                    id='Vector_11'
                    opacity='0.4'
                    d='M81.3681 -119.57C49.8751 -151.086 -4 -128.782 -4 -84.2276V508.341C-4 538.456 31.7457 554.261 54.022 533.995V533.995L254.462 333.411L357.608 226.22C376.49 206.597 376.197 175.472 356.947 156.208L81.3681 -119.57Z'
                    fill='#FFF1ED'
                  />
                </Group>
                <path
                  id='left-1-1'
                  opacity='0.3'
                  d='M-4 54.7534V851.813H718.637L755.56 814.863L254.462 313.402L-4 54.7534Z'
                  fill='#E6D6D1'
                />
                <Group custom={-2} id='left-2-1' opacity='0.4'>
                  <path
                    id='Vector_12'
                    opacity='0.4'
                    d='M-4 455.952V851.842H328.308L359.956 820.171L54.022 514.016L-4 455.952Z'
                    fill='#FFECE5'
                  />
                </Group>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_156_558'
          x1='1633.4'
          y1='110.29'
          x2='-21.5367'
          y2='110.29'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='#FFF7F4' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_156_558'
          x1='1498.85'
          y1='461.719'
          x2='1498.85'
          y2='1050.31'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.1875' stopColor='#FFE7DF' />
          <stop offset='1' stopColor='#FFF6F3' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_156_558'>
          <rect width='1440' height='680' fill='white' />
        </clipPath>
        <clipPath id='clip1_156_558'>
          <rect
            width='1440'
            height='1156'
            fill='white'
            transform='translate(0 -468)'
          />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default OrangeAbstractBackground;
